import { Button, Modal } from 'baby-design'
import Form, { FormSubmitData } from './Form'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { useState } from 'react'
import { convertToRegistryItems, submitCheckout } from '../../api'
import { setGiftGiverCookie } from 'lib/cookies'
import { buildCartItems } from '../../lib'

const formId = 'ez-add-gift-giver-info-form'

const EZAddToCartGiftGiverInfoModal = NiceModal.create(() => {
  const modal = useModal()
  const [submiting, setSubmitting] = useState(false)
  const onSubmit = (formProps: FormSubmitData) => {
    setSubmitting(true)
    convertToRegistryItems(formProps).then((updatedCart) => {
      const { name, email, subscribeToMarketingEmail } = formProps
      setGiftGiverCookie({ name, email, subscribeToMarketingEmail })
      const cartItems = buildCartItems(
        updatedCart.amazonCart,
        updatedCart.cart,
        updatedCart.reservations,
        null,
        false
      )
      submitCheckout(cartItems)
        .then((resp) => {
          modal.resolve(resp)
          modal.hide()
        })
        .catch((resp) => {
          modal.reject(resp)
          modal.hide()
        })
    })
  }

  const submitButton = (
    <Button
      size={'lg'}
      variant="primary"
      type="submit"
      form={formId}
      loading={submiting}
    >
      Submit
    </Button>
  )

  return (
    <Modal
      showCloseButton
      handleClose={modal.hide}
      isOpen={modal.visible}
      mobileVariant="basic"
      primaryButton={submitButton}
      title="Who is this from?"
    >
      <Form id={formId} onSubmit={onSubmit} />
    </Modal>
  )
})

export default EZAddToCartGiftGiverInfoModal
